import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type FeatureTemplateProps = {
  /** A Hero (as="h1") with the page's one primary action and an illustration. */
  hero: ReactNode;
  /** FeatureBlocks, alternating `reverse`, each showing the real component. */
  blocks: ReactNode;
  faq?: { title: ReactNode; content: ReactNode };
  /** A CtaBand; its button is secondary when the hero already has the primary action. */
  cta?: ReactNode;
  className?: string;
};

/** Feature and marketing pages (/features/*, /connector, /about-employer-score, /app). */
export function FeatureTemplate({ hero, blocks, faq, cta, className }: FeatureTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section pb-jc-section">
        {hero}
        <div className="flex flex-col gap-jc-section">{blocks}</div>
        {faq ? (
          <TemplateSection id="faq" title={faq.title} className="max-w-3xl">
            {faq.content}
          </TemplateSection>
        ) : null}
        {cta}
      </div>
    </PageContainer>
  );
}
